import React from 'react';
import ReactTooltip from 'react-tooltip';
import { MISSING_ICON, REVIEWING_ICON, NOT_APPROVED_ICON, APPROVED_ICON } from "../../../../util/cdnAssets";
import { _StageSummary, _StatusCount } from "./style";
var StageSummary = function StageSummary(_ref) {
  var title = _ref.title,
    missing = _ref.missing,
    reviewing = _ref.reviewing,
    not_approved = _ref.not_approved,
    completed = _ref.completed;
  return /*#__PURE__*/React.createElement(_StageSummary, null, /*#__PURE__*/React.createElement(_StatusCount, {
    "data-for": title,
    "data-tip": "Missing",
    statusOf: "missing"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: MISSING_ICON
  }), /*#__PURE__*/React.createElement("div", null, missing)), /*#__PURE__*/React.createElement(_StatusCount, {
    "data-for": title,
    "data-tip": "Reviewing",
    statusOf: "reviewing"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: REVIEWING_ICON
  }), /*#__PURE__*/React.createElement("div", null, reviewing)), /*#__PURE__*/React.createElement(_StatusCount, {
    "data-for": title,
    "data-tip": "Not Approved",
    statusOf: "not_approved"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: NOT_APPROVED_ICON
  }), /*#__PURE__*/React.createElement("div", null, not_approved)), /*#__PURE__*/React.createElement(_StatusCount, {
    "data-for": title,
    "data-tip": "Completed",
    statusOf: "completed"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: APPROVED_ICON
  }), /*#__PURE__*/React.createElement("div", null, completed)), /*#__PURE__*/React.createElement(ReactTooltip, {
    id: title
  }));
};
export default StageSummary;